<template>
  <div class="ips-page-header">
    <div class="ips-cloud__header_container" ref="container">
      <!-- LOGO START -->
      <div class="ips-page-header__logo" ref="logo">
        <img alt src="../assets/images/justbon/logo/yiai-logo-light--h.png"/>
      </div>
      <!-- LOGO END -->

      <div class="ips-page-header__name text-left" ref="title">
        <div class="fs-14 txt-bold">
          <span>智慧服务平台</span>
        </div>
        <div class="fs-8 ips-sub__title">
          <span>Intelligent Service</span>
        </div>
      </div>

      <!-- 显示出来的子系统 START -->
      <ul class="ips-page-header-navigation" ref="nav">
        <li :key="sys.id" class="nav-item x-nav" v-for="sys in apps" v-show="viewApp(sys)">
          <a
            class="ips-sys__link"
            target="_blank"
            v-if="sys.redirect"
            @click="linkClick(sys);return false;"
          >{{ sys.name }}</a>
          <div
            @click="handleClick(sys)"
            class="ips-sys__link"
            v-bind:class="{'active':sys.path === currentAppPath}"
            v-else
          >{{ sys.name }}
          </div>
        </li>

        <!-- 更多 START -->

        <li class="nav-item" ref="more">
          <el-popover
            :width="moreWidth"
            placement="bottom-end"
            popper-class="pd-5"
            ref="popover"
            trigger="hover"
          >
            <ul class="more_container clearfix">
              <li :key="sys.id" class="more_item" v-for="sys in apps" v-show="viewMoreApp(sys)">
                <a
                  @click="linkClick(sys);return false"
                  class="ips-sys__link"
                  target="_blank"
                  v-if="sys.redirect"
                >{{ sys.name }}</a>
                <div
                  @click="handleClick(sys)"
                  class="ips-sys__link"
                  v-bind:class="{'active':sys.path === currentAppPath}"
                  v-else
                >{{ sys.name }}
                </div>
              </li>
            </ul>
          </el-popover>
          <div class="ips-page-header-more">
            <span class="ips-header__more-btn pointer" v-popover:popover>
              更多
              <i class="el-icon-arrow-down"></i>
            </span>
          </div>
        </li>
        <!-- 更多 END -->
      </ul>
      <!-- 显示出来的子系统 END -->

      <!-- 用户信息 START -->
      <div class="ips-page-header-customer fs-12" ref="customer">
        <div>
          <el-dropdown @command="handleCommand" trigger="click">
            <span class="mgr-10">
              <i class="fa fa-user"></i>
              <span class="mgl-8">
                {{ username }}
                <i class="el-icon-arrow-down"></i>
              </span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="message">
                <div>消息</div>
              </el-dropdown-item> -->
              <el-dropdown-item command="password">
                <div>修改密码</div>
              </el-dropdown-item>
              <el-dropdown-item command="logout">
                <div>注销</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <el-dialog :width="SMALL_MODAL_SIZE" title="修改密码"
               v-dialog-drag
               :visible.sync="visible"
               :close-on-click-modal="false"
               :modal="false"
               :before-close="handleClose">
      <div>
        <el-form ref="form" :rules="rules" :model="formObject" label-width="100px">
          <el-form-item label="原始密码:" prop="originalPassword">
            <el-input :type="type" class="jb-password" v-model.trim="formObject.originalPassword">
              <i :class="isLock" class="fs-13" slot="suffix" @click="handlePwdView"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="新密码:" prop="password">
            <el-input :type="type" class="jb-password" v-model.trim="formObject.password">
              <i :class="isLock" class="fs-13" slot="suffix" @click="handlePwdView"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="确认密码:" prop="confirmPassword">
            <el-input :type="type" class="jb-password" v-model.trim="formObject.confirmPassword">
              <i :class="isLock" class="fs-13" slot="suffix" @click="handlePwdView"></i>
            </el-input>
          </el-form-item>

          <el-form-item label-width="0px">
            <el-alert title="新密码将在下次登录时生效!" :closable="false" type="warning"></el-alert>
          </el-form-item>
        </el-form>

        <div class="txt-right">
          <el-button plain @click="handleClose">取消</el-button>
          <el-button type="primary" plain @click="modifyPassword">确定</el-button>
        </div>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import jQ from "jquery";
import _ from "lodash";
import {bus} from "../components";
import axios from "axios";
import {SMALL_MODAL_SIZE} from "@/store/constant";
import {Notification} from "element-ui";
import {updatePassword} from "@/api/staff";

export default {
  name: "PageHeader",
  data() {
    return {
      SMALL_MODAL_SIZE,
      showNumber: 6, // 默认显示多少个子系统
      $window: null,
      visible: false,
      loading: false,
      type: "password",
      formObject: {},
      rules: {
        originalPassword: [{required: true, message: '必填项', trigger: 'blur'}]
        , password: [{required: true, message: '必填项', trigger: 'blur'}
          , {min: 8, message: '长度最少 8 个字符', trigger: 'blur'}]
        , confirmPassword: [{required: true, message: '必填项', trigger: 'blur'}
          , {min: 8, message: '长度最少 8 个字符', trigger: 'blur'}]
      },
      visitIds: []
    };
  },
  props: ["apps", "username", "userId", "currentAppPath", "loginName", "currentUser"],
  computed: {
    ...mapState("app", ["currentUser"]),
    ...mapState("pageHeader", ["userName"]),
    ...mapGetters("app", ["settingApp"]),
    visitApps() {
      return this.apps.slice(0, this.showNumber);
    },
    moreApps() {
      return this.apps.slice(this.showNumber);
    },
    accessToken() {
      return this.$cookie.get("Authorization");
    },
    currentRoute() {
      return null;
    },
    reachSetting() {
      return _.isObject(this.settingApp);
    },
    moreWidth() {
      let appLen = this.apps.length;
      let visitLen = this.visitIds.length;
      let moreLen = appLen - visitLen;
      return (moreLen > 8 ? 8 : moreLen) * 100;
    },
    isLock() {
      return this.type === 'password' ? 'fas fa-eye' : 'fas fa-eye-slash'
    }
  },
  methods: {
    getUrl(sys) {
      let {yspLoginName, yspPassword} = this.currentUser;
      let token = this.accessToken;
      let userId = this.userId;
      let url =
        sys.url + `?access_token=${token}&token=${token}&userId=${userId}`;
      // 专门针对云视频进行特殊传参
      if (sys.code === 'redirect_yunshiping') {
        url = `${sys.url}?username=${yspLoginName}&password=${yspPassword}`
      }
      return url;
    },
    handleClick(sys) {
      if (sys.redirect) return;
      axios.get(`/oauth2/oauth/check_token?token=${this.accessToken}`).then((result) => {
        if (result) this.$emit("active", sys);
      })
    },
    linkClick(sys) {
      axios.get(`/oauth2/oauth/check_token?token=${this.accessToken}`).then((result) => {
        if (!result) return false
        window.open(this.getUrl(sys))
        this.$emit("link", sys);
      })
    },
    activeSetting() {
      this.$emit("active", this.settingApp);
    },
    logout() {
      let token = this.$cookie.get("Authorization");
      axios.delete(`/oauth2/oauth/token/${token}`).then(() => {
        window.location.href = "./login.html";
      });
    },
    async handleModifyPassword() {
      this.visible = true
    },
    handleClose() {
      this.visible = false
      this.formObject = {}
      this.$refs.form.resetFields()
    },
    validateForm() {
      return new Promise((resolve, reject) => {
        let {originalPassword, password, confirmPassword} = this.formObject
        let errTxts = ['#', '&']
        let hasChart = ['~', '!', '@', '$', '%', '^', '*', '.', '?']
        this.$refs.form.validate().then(() => {
          if (password !== confirmPassword) {
            let msg = '新密码和确认密码不一样！'
            Notification.warning(msg)
            reject(msg)
          } else if (errTxts.some(item => password.includes(item))) {
            let msg = `新密码中不能包含以下字符 ${errTxts.join()}！`
            Notification.warning(msg)
            reject(msg)
          } else if (!hasChart.some(item => password.includes(item))) {
            let msg = `新密码中必须包含以下字符 ${hasChart.join()}！`
            Notification.warning(msg)
            reject(msg)
          } else if (password.search(/\d/) < 0 || password.search(/[a-zA-Z]/) < 0) {
            let msg = `新密码中必须包含英文字母和数字！`
            Notification.warning(msg)
            reject(msg)
          } else if (originalPassword === password) {
            let msg = `原密码和新密码不能一样！`
            Notification.warning(msg)
            reject(msg)
          } else {
            resolve(true)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    async modifyPassword() {
      try {
        await this.validateForm()
        let data = Object.assign({}, this.formObject, {id: this.currentUser.id})
        await updatePassword(data)
        Notification.success('修改成功!')
        this.handleClose()
      } catch (e) {
        console.error(e)
      }
    },
    move() {
      let $customer = jQ(this.$refs.customer);
      let $logo = jQ(this.$refs.logo);
      let $title = jQ(this.$refs.title);
      let $nav = jQ(this.$refs.nav);
      let $container = jQ(this.$refs.container);
      let $more = jQ(this.$refs.more);

      let containerWd = $container.width() - 100;
      // logo 和 title 有 margin-right 的设置
      let leftWd = $logo.outerWidth(true) + $title.outerWidth(true);
      let customerWd = $customer.outerWidth();

      let $navItems = [];

      $nav.find(">li.x-nav").each((i, item) => {
        $navItems.push(jQ(item));
      });

      $more.show();
      let tmp = [];
      let i,
        flag = false,
        allWidth = 0,
        navExceptMoreWd =
          containerWd - leftWd - customerWd - $more.outerWidth();
      for (i = 0; i < $navItems.length; i++) {
        let $item = $navItems[i],
          itemWidth = $item.outerWidth();

        if (!flag && navExceptMoreWd < allWidth + itemWidth) {
          flag = true;
        } else {
          allWidth += itemWidth;
        }

        flag ? $more.show() : ($more.hide(), tmp.push(this.apps[i].id));
      }

      this.visitIds = tmp;
    },

    viewApp(app) {
      return this.visitIds.indexOf(app.id) > -1;
    },

    viewMoreApp(app) {
      return this.visitIds.indexOf(app.id) < 0;
    },

    handlePwdView() {
      this.type = this.type === 'password' ? 'text' : 'password'
    },

    handleCommand(command) {
      switch (command) {
        case "message":
          // todo
          break;
        case "setting":
          this.activeSetting();
          break;
        case "logout":
          this.logout();
          break;
        case "password":
          this.handleModifyPassword();
          break;
        default:
        // todo
      }
    }
  },
  mounted() {
    let self = this;
    jQ(window).resize(function () {
      self.move();
    });
    bus.$on("show.app", () => {
      self.move();
    });
  },

  watch: {
    apps(newVal) {
      this.visitIds = this.apps.map(item => item.id);

      if (_.isArray(newVal)) {
        this.$nextTick(() => {
          jQ(window).trigger("resize");
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/page_header";
@import "../assets/scss/utils";

.jb-password {

  /deep/ input {
    cursor: text;
  }

  /deep/ .el-input__suffix {
    cursor: pointer;
  }
}
</style>
